module.exports = require('./lib/jsen.js');


/*****************
 ** WEBPACK FOOTER
 ** ./~/jsen/index.js
 ** module id = 8
 ** module chunks = 0
 **/